import { render } from "./LadderSkeleton.vue?vue&type=template&id=3b1a6438&scoped=true"
import script from "./LadderSkeleton.vue?vue&type=script&lang=js"
export * from "./LadderSkeleton.vue?vue&type=script&lang=js"

import "./LadderSkeleton.vue?vue&type=style&index=0&id=3b1a6438&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0add72b42d7a2609c-1/assemble-sports/unisports-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1a6438"]])

export default __exports__